import React from "react";
import { renderContentWithLineBreaks } from "../utils/renderContentWithLineBreaks";

interface CommercialSectionProps {
    heading: string;
    content: string;
    className?: string;
    contentTextSize?: string;
    headingClassName?: string; // Add this prop
}

const CommercialSection: React.FC<CommercialSectionProps> = ({
    heading,
    content,
    className = "",
    contentTextSize = "text-base sm:text-lg md:text-xl lg:text-2xl", // Default text size
    headingClassName = "", // Add this prop

}) => (
    <div className={`mb-8 px-2 sm:px-4 md:px-8 lg:px-16 ${className}`}>
        <h2 className={`${headingClassName}`}>
            {heading}
        </h2>
        <div className={`font-sans text-[#232b18] p-2 ${contentTextSize}`}>
            {renderContentWithLineBreaks(content)}
        </div>
    </div>
);

export default CommercialSection;